import { render, staticRenderFns } from "./AccountHolderExpenses.vue?vue&type=template&id=c2d912a4&scoped=true"
import script from "./AccountHolderExpenses.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenses.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenses.vue?vue&type=style&index=0&id=c2d912a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d912a4",
  null
  
)

export default component.exports